import { useEffect } from 'react';
import { ensureWorkersStarted } from '../../user-metrics/utils/userMetricsWorkerPool';

/**
 * Starts the User Metrics worker pool as soon as the OE providers mount.
 *
 * The workers' script chunk is large (it pulls in moment via the worker utils), and
 * messages posted to a worker whose script is still loading are buffered rather than
 * dropped — so creating them lazily puts the whole download + compile on the critical
 * path *after* the S3 fetch resolves. Starting them here overlaps that cost with the
 * fetch instead, which is the same idea as the chunk preloading in lazyRoutes.ts.
 *
 * Deliberately mounted alongside the OE providers rather than inside
 * `UserMetricsProvider`: that provider is also mounted by the `/ea-huddle` route, which
 * consumes the parsed rows but never dispatches to the workers, so warming there would
 * spawn three permanently idle threads for EA Huddle users.
 *
 * `ensureWorkersStarted` is idempotent, so a remount (React StrictMode double-mounts in
 * dev) is a no-op rather than a second round of script loads.
 */
export const useWarmUserMetricsWorkers = (): void => {
  useEffect(() => {
    ensureWorkersStarted();
  }, []);
};
